import StockoutReceiverSelect from "./stockoutReceiverSelect.container";

export default StockoutReceiverSelect;
